import { useCallback } from "react";

interface UsePhoneFormatterOptions {
  hideMiddleDigits?: boolean;
}

export const usePhoneFormatter = ({
  hideMiddleDigits = true,
}: UsePhoneFormatterOptions = {}) => {
  const formatPhoneNumber = useCallback(
    (phone: string) => {
      if (!phone) return "***";

      const digits = phone.replace(/\D/g, "");
      if (digits.length < 4) return "***";

      if (hideMiddleDigits) {
        return `${digits.slice(0, 3)} *** ** ${digits.slice(-2)}`;
      }

      return digits.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
    },
    [hideMiddleDigits],
  );

  return { formatPhoneNumber };
};
